const bubbles = () => {

  let particle = function(id,color,amount = 20) {
    const rAmount = parseInt(amount);
    const rColor = (color == '' ? '#ffffff' : color);
    setTimeout(function () {
      window.particlesJS(id, {
      "particles": {
        "number": {
          "value": rAmount,
          "density": {
            "enable": true,
            "value_area": ((window.innerWidth / rAmount) < 2000 ? 2000 : (window.innerWidth / rAmount))
          }
        },
        "color": {
          "value": rColor
        },
        "shape": {
          "type": "circle",
          "stroke": {
            "width": 0,
            "color": "#000000"
          },
          "polygon": {
            "nb_sides": 0
          },
        },
        "opacity": {
          "value": 1,
          "random": {
            "enable": true,
            "minimumValue": 0.95
          },
          "anim": {
            "enable": false,
            "speed": 1,
            "opacity_min": 0.8,
            "sync": false
          }
        },
        "size": {
          "value": 80,
          "random": {
            "enable": true,
            "minimumValue": 10
          }
        },
        "line_linked": {
          "enable": false,
        },
        "move": {
          "enable": false
        }
      },
      "interactivity": {
        "detect_on": "window",
        "events": {
          "onhover": {
            "enable": false,
          },
          "onclick": {
            "enable": false,
          },
          "resize": true
        },
        "modes": {

        }
      },
      "retina_detect": true
    });
    },100);
  }

  document.addEventListener("DOMContentLoaded", function(){

    let sections = [{name:'BC-1',color: '#5a5762'},{name:'BC-2',color: '#fbf9f9'},{name:'BC-3',color:'#fcfafa'},{name:'BC-4',color:'#faf5f0'},{name:'BC-5',color:'#ffffff'},{name:'BC-6',color:''},{name:'BC-7',color:'#ffffff'},{name:'GC-1',color:'#f8f2ec'},{name:'GC-2',color:'#ffffff'},{name:'GC-3',color:'#fcfbfb'},{name:'GC-4',color:'#fbf9f9'},{name:'GC-5',color:'#fdfbfb'},{name:'GC-6',color:''},{name:'GC-7',color:'#f9f6f4'},{name:'GC-8',color:'#ffffff'},{name:'GC-9',color:'#ffffff'},{name:'GC-10',color:''},{name:'GC-11',color:''},{name:'GC-12',color:''},{name:'GC-13',color:''},{name:'GC-14',color:'#ffffff'},{name:'GC-15',color:''},{name:'GC-16',color:''},{name:'GC-17',color:'#ffffff'},{name:'GC-18',color:'#ffffff'},{name:'GC-19',color:'#f9f6f4'},{name:'GC-20',color:'#faf9f8'},{name:'GC-21',color:'#faf8f6'},{name:'GC-22',color:'#f9f6f4'},{name:'GC-23',color:''},{name:'GC-24',color:'#ffffff'},{name:'GC-25',color:''},{name:'GC-26',color:''},{name:'GC-27',color:'#fbf9f9'},{name:'GC-28',color:'#faf8f7'},{name:'GC-29',color:''},{name:'GC-30',color:'#ffffff'}];
    Array.from(sections).forEach(function(section) {
      const sectionElements = document.getElementsByClassName('c-section--'+section.name);
      Array.from(sectionElements).forEach(function(sectionElement) {
        if(sectionElement.id) {
          const amount = sectionElement.dataset.bubbleAmount;
          particle(sectionElement.id, section.color,amount);
        }
      });
    });

  });
};

export default bubbles;
